import React, { PropsWithChildren, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { YouTubeEmbed } from 'react-social-media-embed';


/**
 * @interface IEmbedYouTubeProps declares any input properties required for this component.
 */
export interface IEmbedYouTubeProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedYouTube is a React functional component for displaying a Facebook social media post.
 * @param {} props are the properties passed into the component.
 */
export const EmbedYouTube: React.FC<IEmbedYouTubeProps> = (props: IEmbedYouTubeProps) => {
  EmbedYouTube.displayName = 'EmbedYouTube';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedYouTube. Entered EmbedYouTube`);

  const { url, postWidth, postHeight } = props;

  return (
    <>
      {/* <YouTubeEmbed url={url} width={postWidth} height={postHeight} /> */}

      <ReactPlayer
        url={url}
        crossOrigin="anonymous"
        playsinline={true}
        controls={true}
        position='relative'
        width={postWidth}
        height={postHeight}
      />

    </>
  )
}
